
import React from 'react';
import CodeOfConduct from '../components/CodeOfConduct';
import Footer from '../components/Footer';


function CodeConduct() {
  return (
    <>
        <CodeOfConduct />
        <Footer />
    </>
  );
}


export default CodeConduct;
